let _ = require('lodash');

/**
 * Если пользователь убрал галку со стоблца выгрузки соответсвующего дереву, то надо снять все гакли из дерева
 * @param path
 * @param propertyName
 * @param setAllFunction
 * @param state
 */
function tryUnsetAllSelected ({ path, propertyName, setAllFunction }, state) {
    let exportColumn = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']),
        { propertyName: propertyName });
    if (exportColumn && path === exportColumn.id) {
        setAllFunction({ value: false }, state);
    }
}

/**
 * Если пользователь отметил что-то в дереве, то нужно отметить колонку
 * @param value
 * @param propertyName
 * @param state
 */
function setExportColumnIsChecked({ value, propertyName }, state) {
    let exportColumn = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']),
        { propertyName: propertyName });
    if (exportColumn) {
        state.set(['order', 'addParams', 'exportColumns', exportColumn.id, 'isChecked'], value);
    }
}

module.exports = {
    tryUnsetAllSelected,
    setExportColumnIsChecked
};



// WEBPACK FOOTER //
// ./actions/custom-order/export-column-helper.js